// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"151ffd37","331":"da2968d7","358":"7ff68408","367":"d2139deb","370":"ea39def5","439":"7f06945d","467":"a2b19a14","485":"50f6a074","556":"da921bdc","631":"e2acbde2","787":"b2f22f8d","837":"8b5143a1"}[chunkId] + ".chunk.js";
};